import * as types from '../../types';

export const WATCHED_ABOUT_US_FIELD_KEYS: (
  | keyof types.AboutUsFormValues
  | 'emergencyContact.email'
  | 'emergencyContact.name'
  | 'emergencyContact.phone'
)[] = ['emergencyContact.email', 'emergencyContact.name', 'emergencyContact.phone', 'tags', 'id'];
